// DS: INT01D
import React from 'react';
import classnames from 'classnames';
import Attribution from '../../DeviationViews/Helper/Attribution';
import Overlay from './Overlay';
import GallectionCommentControl from './GallectionCommentControl';
import { ThemeOverride } from '../../Context';
import { ThemeOptions } from '../../publicSession/types';
import { gallectionTypeToResourceType } from '../../types/gallection';
import s from './CollectionCardOverlay.scss';
export var CollectionCardOverlay = function (_a) {
    var gallection = _a.gallection, className = _a.className;
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
        React.createElement(Overlay, { className: classnames(s['root'], className) },
            React.createElement(Attribution, { showAuthorTooltip: true, relatedItemBiData: {
                    typeid: gallectionTypeToResourceType(gallection.type),
                    itemid: gallection.folderId,
                }, author: gallection.owner, className: s['attribution'], userlinkClassName: s['user-link'] }),
            React.createElement(GallectionCommentControl, { gallection: gallection, className: s['comments'], iconClassName: s['comment-icon'] }))));
};
CollectionCardOverlay.displayName = 'CollectionCardOverlay';
export default CollectionCardOverlay;
//# sourceMappingURL=CollectionCardOverlay.js.map